/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const log = require('../../util/log');
const formatMessage = require('format-message');
const Cast = require('../../util/cast');
const FileSaver = require('file-saver');
const util = require('../../engine/block-utility');
const StringUtil = require('../../util/string-util');
const Sb2CppConverter = require('./sb2cpp');
const Avrgirl = require('avrgirl-arduino');
const ArduinoWriter = require('./arduino-writer');
const {color} = require('minilog/lib/web/console');
const TinyMLExtension = require('../kurikit_tinyml/index');
const env = require('../env');
const describeSerialPort = require('../../util/serial-port-info');

const developBuildServer = 'https://staging.build.kurikit.ux-xu.com/exec/post';
// ローカルの build-server（docker compose up build-server → localhost:8080）を使うときは上と入れ替えてコメントイン
// const developBuildServer = 'http://localhost:8080/exec/post';
const BUILD_SERVER_URL = env === 'production' ?
    'https://build.kurikit.ux-xu.com/exec/post' : developBuildServer;

class CompileError extends Error {
    static {
        this.prototype.name = 'CompileError';
    }
}

/**
 * Icon svg to be displayed at the left edge of each extension block, encoded as a data URI.
 * @type {string}
 */
const blockIconURI = 'data:image/svg+xml;base64,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';
const menuIconURI = 'data:image/svg+xml;base64,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';

// この拡張機能で有効な多言語表示
const AvailableLocales = ['en', 'ja', 'ja-Hira'];

// 多言語化に使用するjsonです。
const Message = {
    categoryName: {
        'ja': 'メイカーボード きほんブロック',
        'ja-Hira': 'メイカーボード きほんブロック',
        'en': 'MakerBoard Basic'
    },
    help: {
        'ja': '使い方を表示する',
        'ja-Hira': 'つかいかたをひょうじする',
        'en': 'show usage'
    },
    starthat: {
        'ja': 'スタート',
        'ja-Hira': 'スタート',
        'en': 'start'
    },
    loopcode: {
        'ja': '繰り返し動かす',
        'ja-Hira': 'くりかえしうごかす',
        'en': 'loop'
    },
    servo: {
        'ja': '青いモーター[SERVO]を[ANGLE]度にする',
        'ja-Hira': 'あおいモーター[SERVO]を[ANGLE]どにする',
        'en': 'set blue motor [SERVO] to [ANGLE] deg'
    },
    motorforwardsimple: {
        'ja': '黄色いモーター[MOTOR]を回転',
        'ja-Hira': 'きいろいモーター[MOTOR]をまわす',
        'en': 'spin yellow motor [MOTOR]'
    },
    motorbackwardsimple: {
        'ja': '黄色いモーター[MOTOR]を逆回転',
        'ja-Hira': 'きいろいモーター[MOTOR]をぎゃくにまわす',
        'en': 'reverse spin yellow motor [MOTOR]'
    },
    motorforward: {
        'ja': '黄色いモーター[MOTOR]を[DURATION]で回転',
        'ja-Hira': 'きいろいモーター[MOTOR]を[DURATION]でまわす',
        'en': 'spin yellow motor [MOTOR] by [DURATION]'
    },
    motorbackward: {
        'ja': '黄色いモーター[MOTOR]を[DURATION]で逆回転',
        'ja-Hira': 'きいろいモーター[MOTOR]を[DURATION]でぎゃくにまわす',
        'en': 'reverse spin yellow motor [MOTOR] by [DURATION]'
    },
    motorstop: {
        'ja': '黄色いモーター[MOTOR]をとめる',
        'ja-Hira': 'きいろいモーター[MOTOR]をとめる',
        'en': 'stop yellow motor [MOTOR]'
    },
    led: {
        'ja': 'ボード上のLED[PIN]を[OUTPUT]',
        'ja-Hira': 'ボードじょうのLED[PIN]を[OUTPUT]',
        'en': 'on-board LED [PIN] to [OUTPUT]'
    },
    buttonbool: {
        'ja': 'スイッチセンサ [PIN]が[BOOL]',
        'ja-Hira': 'スイッチセンサ [PIN]が[BOOL]',
        'en': 'switch sensor [PIN] is [BOOL]'
    },
    touch: {
        'ja': 'タッチセンサ [PIN]が[BOOL]',
        'ja-Hira': 'タッチセンサ [PIN]が[BOOL]',
        'en': 'touch sensor [PIN] is [BOOL]'
    },
    joystickpush: {
        'ja': 'ジョイスティック ピン[PIN]が押された',
        'ja-Hira': 'ジョイスティック ピン[PIN]がおされた',
        'en': 'joystick pin [PIN] is pressed'
    },
    joystick: {
        'ja': 'ジョイスティック ピン[PIN]の[AXIS]のあたい',
        'ja-Hira': 'ジョイスティック ピン[PIN]の[AXIS]のあたい',
        'en': 'joystick pin [PIN] [AXIS] value'
    },
    rotary: {
        'ja': '角度センサ ピン[PIN]のあたい(度)',
        'ja-Hira': 'かくどセンサ ピン[PIN]のあたい(ど)',
        'en': 'angle sensor pin [PIN] value (deg)'
    },
    sound: {
        'ja': '音センサ ピン[PIN]のあたい',
        'ja-Hira': 'おとセンサ ピン[PIN]のあたい',
        'en': 'sound sensor pin [PIN] value'
    },
    write: {
        'ja': 'プログラムをボードに書き込む',
        'ja-Hira': 'プログラムをボードにかきこむ',
        'en': 'write program to board'
    },
    exportFile: {
        'ja': 'プログラムをダウンロード',
        'ja-Hira': 'プログラムをダウンロード',
        'en': 'download program'
    },
    errorMesg: {
        'ja': 'プログラムのエラーメッセージ',
        'ja-Hira': 'プログラムのエラーメッセージ',
        'en': 'program error message'
    },
    led_red: {
        'ja': 'あか',
        'ja-Hira': 'あか',
        'en': 'red'
    },
    led_blue: {
        'ja': 'あお',
        'ja-Hira': 'あお',
        'en': 'blue'
    },
    axis_horizontal: {
        'ja': 'よこ',
        'ja-Hira': 'よこ',
        'en': 'horizontal'
    },
    axis_vertical: {
        'ja': 'たて',
        'ja-Hira': 'たて',
        'en': 'vertical'
    },
    alertMultipleStart: {
        'ja': 'スタートブロックは１つにしてください',
        'ja-Hira': 'スタートブロックは１つにしてください',
        'en': 'Please use only one start block'
    },
    alertMultipleLoop: {
        'ja': '繰り返し動かすブロックは１つにしてください',
        'ja-Hira': 'くりかえしうごかすブロックは１つにしてください',
        'en': 'Please use only one loop block'
    },
    alertBlocksBelowLoop: {
        'ja': '繰り返し動かすの下側にブロックをおいてはいけません',
        'ja-Hira': 'くりかえしうごかすのしたにブロックをおいてはいけません',
        'en': 'Do not place blocks below the loop block'
    },
    alertDuplicateDefinition: {
        'ja': '同じ名前 (”[NAME]”)のブロック定義があります．',
        'ja-Hira': 'おなじなまえ (”[NAME]”)のブロックていぎがあります．',
        'en': 'Duplicate block definition name (”[NAME]”).'
    },
    alertNoStartOrLoop: {
        'ja': 'スタートブロックまたは繰り返しブロックがありません',
        'ja-Hira': 'スタートブロックまたはくりかえしブロックがありません',
        'en': 'No start block or loop block found'
    },
    alertTinyMLNotTrained: {
        'ja': 'TinyMLモデルが学習されていません。\n\n先に以下を実行してください：\n1. TinyML拡張機能で「センサーをセットアップ」\n2. 各ラベルのデータを収集（最低5秒×3ラベル）\n3. 「モデルを学習する」を実行',
        'ja-Hira': 'TinyMLモデルがまだがくしゅうされていません。\n\nさきにつぎをじっこうしてください：\n1. TinyMLかくちょうきのうで「センサーをセットアップ」\n2. かくラベルのデータをあつめる（さいてい5びょう×3ラベル）\n3. 「モデルをがくしゅうする」をじっこう',
        'en': 'TinyML model is not trained.\n\nPlease do the following first:\n1. "Setup sensor" in TinyML extension\n2. Collect data for each label (min 5 sec x 3 labels)\n3. Run "Train model"'
    },
    alertTinyMLPlaceholderMissing: {
        'ja': 'TinyMLプレースホルダーが見つかりません。\n「推論を更新」ブロックを使用していますか？',
        'ja-Hira': 'TinyMLプレースホルダーがみつかりません。\n「すいろんをこうしん」ブロックをつかっていますか？',
        'en': 'TinyML placeholder not found.\nAre you using the "Update inference" block?'
    },
    alertTinyMLIntegrationFailed: {
        'ja': 'TinyMLモデルの統合に失敗しました:\n[MESSAGE]\n\n詳細はコンソールを確認してください',
        'ja-Hira': 'TinyMLモデルのとうごうにしっぱいしました:\n[MESSAGE]\n\nくわしくはコンソールをかくにんしてください',
        'en': 'Failed to integrate TinyML model:\n[MESSAGE]\n\nSee console for details'
    },
    confirmWrite: {
        'ja': 'プログラムを書き込みますか？',
        'ja-Hira': 'プログラムをかきこみますか？',
        'en': 'Write program?'
    },
    errorWebSerialNotSupported: {
        'ja': 'Web Serial APIがサポートされていません',
        'ja-Hira': 'Web Serial APIがサポートされていません',
        'en': 'Web Serial API is not supported'
    },
    errorPortSelection: {
        'ja': 'ポート選択エラー: ',
        'ja-Hira': 'ポートせんたくエラー: ',
        'en': 'Port selection error: '
    },
    alertPortSelected: {
        'ja': 'シリアルポートが選択されました。コンパイルを開始します。',
        'ja-Hira': 'シリアルポートがえらばれました。コンパイルをはじめます。',
        'en': 'Serial port selected. Starting compile.'
    },
    alertCompileDone: {
        'ja': 'コンパイル終了しました．書き込みます．',
        'ja-Hira': 'コンパイルがおわりました．かきこみます．',
        'en': 'Compile complete. Writing.'
    },
    alertUSBAccessError: {
        'ja': 'USBにアクセスできませんでした．ブラウザの設定でシリアルポートの接続を許可してください．',
        'ja-Hira': 'USBにアクセスできませんでした．ブラウザのせっていでシリアルポートのせつぞくをきょかしてください．',
        'en': 'Could not access USB. Please allow serial port connection in browser settings.'
    },
    alertWriteFailedUSB: {
        'ja': 'プログラムの書き込みにしっぱいしました．USBポートが正しいか，かくにんしてください．メッセージを受信中であれば，一度接続を切断してください',
        'ja-Hira': 'プログラムのかきこみにしっぱいしました．USBポートがただしいか，かくにんしてください．メッセージをじゅしんちゅうであれば，いちどせつぞくをきってください',
        'en': 'Program write failed. Please check USB port is correct. If receiving messages, disconnect first.'
    },
    alertWriteSuccess: {
        'ja': 'プログラムをかきこみました！',
        'ja-Hira': 'プログラムをかきこみました！',
        'en': 'Program written!'
    },
    alertWriteFailedCompile: {
        'ja': 'プログラムの書き込みにしっぱいしました．プログラムが正しいか，かくにんしてください．',
        'ja-Hira': 'プログラムのかきこみにしっぱいしました．プログラムがただしいか，かくにんしてください．',
        'en': 'Program write failed. Please check the program is correct.'
    },
    alertTimeout: {
        'ja': '接続がタイムアウトしました．インターネット環境をご確認ください．',
        'ja-Hira': 'せつぞくがタイムアウトしました．インターネットかんきょうをかくにんしてください．',
        'en': 'Connection timed out. Please check your internet connection.'
    },
    alertServerError: {
        'ja': 'サーバーに接続できません．インターネット接続をご確認ください．改善しない場合は，https://kurikit.ux-xu.com/support/ からお問合せください',
        'ja-Hira': 'サーバーにせつぞくできません．インターネットせつぞくをかくにんしてください．かいぜんしないばあい，https://kurikit.ux-xu.com/support/ からおといあわせください',
        'en': 'Cannot connect to server. Please check your internet connection. If the issue persists, contact https://kurikit.ux-xu.com/support/'
    },
    alertGenericError: {
        'ja': 'エラー\nhttps://kurikit.ux-xu.com/support/ からお問合せください',
        'ja-Hira': 'エラー\nhttps://kurikit.ux-xu.com/support/ からおといあわせください',
        'en': 'Error\nContact https://kurikit.ux-xu.com/support/'
    },
    // タイマー割り込みブロック関連
    alertTimerOutsideLoop: {
        'ja': 'タイマー割り込みブロックは『繰り返し動かす』ブロックの外に置いてください',
        'ja-Hira': 'タイマーわりこみブロックは『くりかえしうごかす』ブロックのそとにおいてください',
        'en': 'Place the timer interrupt block outside the loop block'
    },
    alertMultipleTimer: {
        'ja': 'タイマー割り込みブロックは１つにしてください',
        'ja-Hira': 'タイマーわりこみブロックは１つにしてください',
        'en': 'Please use only one timer interrupt block'
    },
    alertBlocksBelowTimer: {
        'ja': 'タイマー割り込みブロックの下側にブロックをおいてはいけません',
        'ja-Hira': 'タイマーわりこみブロックのしたにブロックをおいてはいけません',
        'en': 'Do not place blocks below the timer interrupt block'
    },
    alertTimerIntervalNotNumber: {
        'ja': 'タイマー割り込みの周期には数字を指定してください',
        'ja-Hira': 'タイマーわりこみのしゅうきにはすうじをしていしてください',
        'en': 'Please specify a number for the timer interrupt interval'
    },
    alertDelayInsideTimer: {
        'ja': 'タイマー割り込みの中では「待つ」ブロックなど遅延を伴うブロックは使用できません',
        'ja-Hira': 'タイマーわりこみのなかでは「まつ」ブロックなどちえんをともなうブロックはつかえません',
        'en': 'Wait blocks and other delay blocks cannot be used inside timer interrupt'
    },
    alertListInsideTimer: {
        'ja': 'リストブロックはタイマー割り込みの中では使用できません',
        'ja-Hira': 'リストブロックはタイマーわりこみのなかではつかえません',
        'en': 'List blocks cannot be used inside timer interrupt'
    },
    alertTimerMotorConflict: {
        'ja': '速度を指定するモーターブロックはタイマー割り込みブロックと一緒に使用できません',
        'ja-Hira': 'スピードをしていするモーターブロックはタイマーわりこみブロックといっしょにつかえません',
        'en': 'Speed-controlled motor blocks cannot be used together with timer interrupt block'
    },
    alertVariableSharedWithTimer: {
        'ja': '変数「[NAMES]」がタイマー割り込みブロックと通常処理の両方で使用されています。誤動作の原因となるため，どちらか一方で使用してください。',
        'ja-Hira': 'へんすう「[NAMES]」がタイマーわりこみブロックとふつうのしょりのりょうほうでつかわれています。ごどうさのげんいんになるため，どちらかいっぽうでつかってください。',
        'en': 'Variable "[NAMES]" is used both inside the timer interrupt and regular code. This may cause malfunctions; please use it in only one place.'
    }
};

let src_include = '';
let src_init = '';
let src_func = '';
let src_setup = '';
let src_loop = '';

const LED_PINS = {
    ONE: 'board.LED_RED',
    TWO: 'board.LED_BLUE'
};
const INOUT_PINS = {
    ONE: 'Port1',
    TWO: 'Port2'
};

const INPUT_PINS = {
    ONE: 'Port1',
    TWO: 'Port2',
    THREE: 'Port3'
};


// 7セグの選択式文字入力用
const SEVEN_SEGMENT_TEXT = {
    LOVE: 'L0UE',
    GO: 'G0',
    ON: '0N',
    OFF: '0FF',
    OK: '0K',
    NG: 'nG'
};


const OUTPUT_BOOLEAN = {
    ON: '1',
    OFF: '0'
};

const COLOR = {
    R: 'red',
    G: 'green',
    B: 'blue',
    C: 'clear'
};


class MakerBoard {
    constructor (runtime) {
        this.runtime = runtime;
        this.runtime.registerPeripheralExtension('makerBoard', this);
        this.existFunctionNames = new Set();
        this.writeFile = false;
        this.isLoop = false;
        this.sources = '';
        this.isRecieveMessage = false;
        this.stopFlag = false;
        this.readFlag = false;
        this.message1 = '';
        this.message2 = '';
        this.message3 = '';
        this.errorMessage = '';
        this.writeMessage = '';
        this.port;
    }

    getInfo () {
        return {
            id: 'makerBoard',
            name: Message.categoryName[this.setLocale()],
            blockIconURI: blockIconURI,
            menuIconURI: menuIconURI,
            color1: '#DDAF38', // ブロックのメイン色
            color2: '#C49B32', // ブロックの影の色
            blocks: [
                {
                    opcode: 'help',
                    blockType: BlockType.COMMAND,
                    text: Message.help[this.setLocale()]
                },
                '---',
                {
                    opcode: 'starthat',
                    blockType: BlockType.HAT,
                    text: Message.starthat[this.setLocale()]
                },
                {
                    opcode: 'loopcode',
                    blockType: BlockType.LOOP,
                    text: Message.loopcode[this.setLocale()]
                },
                '---',
                {
                    opcode: 'servo',
                    blockType: BlockType.COMMAND,
                    text: Message.servo[this.setLocale()],
                    arguments: {
                        SERVO: {
                            type: ArgumentType.NUMBER,
                            menu: 'servo',
                            defaultValue: 1
                        },
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 90
                        }
                    }
                },
                {
                    opcode: 'motorforwardsimple',
                    blockType: BlockType.COMMAND,
                    text: Message.motorforwardsimple[this.setLocale()],
                    arguments: {
                        MOTOR: {
                            type: ArgumentType.NUMBER,
                            menu: 'motor',
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'motorbackwardsimple',
                    blockType: BlockType.COMMAND,
                    text: Message.motorbackwardsimple[this.setLocale()],
                    arguments: {
                        MOTOR: {
                            type: ArgumentType.NUMBER,
                            menu: 'motor',
                            defaultValue: 1
                        }
                    }
                },
                {
                    opcode: 'motorforward',
                    blockType: BlockType.COMMAND,
                    text: Message.motorforward[this.setLocale()],
                    arguments: {
                        MOTOR: {
                            type: ArgumentType.NUMBER,
                            menu: 'motor',
                            defaultValue: 1
                        },
                        DURATION: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        }
                    }
                },
                {
                    opcode: 'motorbackward',
                    blockType: BlockType.COMMAND,
                    text: Message.motorbackward[this.setLocale()],
                    arguments: {
                        MOTOR: {
                            type: ArgumentType.NUMBER,
                            menu: 'motor',
                            defaultValue: 1
                        },
                        DURATION: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        }
                    }
                },
                {

                    opcode: 'motorstop',
                    blockType: BlockType.COMMAND,
                    text: Message.motorstop[this.setLocale()],
                    arguments: {
                        MOTOR: {
                            type: ArgumentType.NUMBER,
                            menu: 'motor',
                            defaultValue: 1
                        }
                    }
                },
                '---',
                {
                    opcode: 'led',
                    blockType: BlockType.COMMAND,
                    text: Message.led[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'led_pins',
                            defaultValue: LED_PINS.ONE
                        },
                        OUTPUT: {
                            type: ArgumentType.STRING,
                            menu: 'output',
                            defaultValue: 'HIGH'
                        }
                    }
                },
                '---',
                {
                    opcode: 'buttonbool',
                    blockType: BlockType.BOOLEAN,
                    text: Message.buttonbool[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        },
                        BOOL: {
                            type: ArgumentType.STRING,
                            menu: 'output',
                            defaultValue: 'HIGH'
                        }
                    }
                },
                {
                    opcode: 'touch',
                    blockType: BlockType.BOOLEAN,
                    text: Message.touch[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        },
                        BOOL: {
                            type: ArgumentType.STRING,
                            menu: 'output',
                            defaultValue: 'HIGH'
                        }
                    }
                },
                {
                    opcode: 'joystickpush',
                    blockType: BlockType.BOOLEAN,
                    text: Message.joystickpush[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        }
                    }
                },
                '---',
                {
                    opcode: 'joystick',
                    blockType: BlockType.REPORTER,
                    text: Message.joystick[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.NUMBER,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        },
                        AXIS: {
                            type: ArgumentType.STRING,
                            menu: 'axis'
                        }
                    }
                },
                {
                    opcode: 'rotary',
                    blockType: BlockType.REPORTER,
                    text: Message.rotary[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        }
                    }
                },
                {
                    opcode: 'sound',
                    blockType: BlockType.REPORTER,
                    text: Message.sound[this.setLocale()],
                    arguments: {
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'input_pins',
                            defaultValue: INPUT_PINS.ONE
                        }
                    }
                },
                '---',
                {
                    opcode: 'write',
                    blockType: BlockType.COMMAND,
                    text: Message.write[this.setLocale()]
                },
                {
                    opcode: 'exportFile',
                    blockType: BlockType.COMMAND,
                    text: Message.exportFile[this.setLocale()]
                },
                {
                    opcode: 'errorMesg',
                    blockType: BlockType.REPORTER,
                    text: Message.errorMesg[this.setLocale()]
                }
            ],

            menus: {
                led_pins: {
                    acceptReporters: true,
                    items: this.LED_PIN_MENU
                },
                inout_pins: {
                    acceptReporters: true,
                    items: this.INOUT_PIN_MENU
                },
                input_pins: {
                    acceptReporters: true,
                    items: this.INPUT_PIN_MENU
                },
                servo: {
                    acceptReporters: true,
                    items: this.SERVO_MENU
                },
                motor: {
                    acceptReporters: true,
                    items: this.MOTOR_MENU
                },
                output: {
                    acceptReporters: true,
                    items: this.OUTPUT_MENU
                },
                axis: {
                    acceptReporters: true,
                    items: this.AXIS_MENU
                }

            }
        };
    }
    get SERVO_MENU (){
        return [
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            },
            {
                text: '4',
                value: '4'
            }
        ];
    }

    get MOTOR_MENU (){
        return [
            {
                text: '1',
                value: '1'
            },
            {
                text: '2',
                value: '2'
            },
            {
                text: '3',
                value: '3'
            },
            {
                text: '4',
                value: '4'
            }
        ];
    }
    get LED_PIN_MENU (){
        return [
            {
                text: Message.led_red[this.setLocale()],
                value: LED_PINS.ONE
            },
            {
                text: Message.led_blue[this.setLocale()],
                value: LED_PINS.TWO
            }
        ];
    }
    get OUTPUT_MENU (){
        return [
            {
                text: 'ON',
                value: 'HIGH'
            },
            {
                text: 'OFF',
                value: 'LOW'
            }
        ];
    }
    get INOUT_PIN_MENU (){
        return [
            {
                text: '1',
                value: INOUT_PINS.ONE
            },
            {
                text: '2',
                value: INOUT_PINS.TWO
            }
        ];
    }
    get INPUT_PIN_MENU (){
        return [
            {
                text: '1',
                value: INPUT_PINS.ONE
            },
            {
                text: '2',
                value: INPUT_PINS.TWO
            },
            {
                text: '3',
                value: INPUT_PINS.THREE
            }
        ];
    }
    get AXIS_MENU (){
        return [
            {
                // TODO: ２１日になったらたてに変える
                // text: 'たて',
                text: Message.axis_horizontal[this.setLocale()],
                value: '0'
            },
            {
                // TODO: ２１日になったらよこに変える
                // text: 'よこ',
                text: Message.axis_vertical[this.setLocale()],
                value: '1'
            }
        ];
    }

    help (){
        const helpURL = 'https://makerboard.ux-xu.com/?v=18475fc53f3b814dbbaf000caa140174&p=18475fc53f3b813b8f4ed50a28e97e61&pm=s';
        window.open(helpURL);
    }

    async generate (){
        this.initialize();
        const jsons = this.toJSON();
        const converter = new Sb2CppConverter();
        const jsonObject = JSON.parse(jsons);

        let variables; let lists; let blocks;
        let writeFlag = false;
        let loopCodeCount = 0;
        let setupCodeCount = 0;
        let timerInterruptCount = 0;

        if ('targets' in jsonObject) {
            variables = jsonObject.targets[0].variables;
            lists = jsonObject.targets[0].lists;
            blocks = jsonObject.targets[1].blocks; // 配置されている全てのブロックの一覧．
        }
        // タイマー割り込みSUBSTACK内で参照される変数/リストを事前収集 (volatile宣言判断に使う)
        for (const id in blocks) {
            if (blocks[id].opcode === 'makerBoardAdvance_timerLoop' && !blocks[id].parent) {
                if (blocks[id].inputs && 'SUBSTACK' in blocks[id].inputs) {
                    const insideId = blocks[id].inputs.SUBSTACK[1];
                    const refs = converter.collectTimerSharedRefs(insideId, blocks);
                    refs.vars.forEach(n => converter.timerSharedVars.add(n));
                    refs.lists.forEach(n => converter.timerSharedLists.add(n));
                }
            }
        }
        // リストはISR内で動的メモリを扱うため使用禁止
        if (converter.timerSharedLists.size > 0) {
            alert(Message.alertListInsideTimer[this.setLocale()]);
            writeFlag = false;
        }
        // メイン側(starthat / loopcode / procedures_definition)で参照される変数を収集
        if (converter.timerSharedVars.size > 0) {
            const mainSideVars = new Set();
            for (const id in blocks) {
                const op = blocks[id].opcode;
                const isMainTop = (op === 'makerBoard_starthat' ||
                                   op === 'makerBoard_loopcode' ||
                                   op === 'procedures_definition');
                if (isMainTop && !blocks[id].parent) {
                    const refs = converter.collectTimerSharedRefs(id, blocks);
                    refs.vars.forEach(n => mainSideVars.add(n));
                }
            }
            const sharedNames = [...converter.timerSharedVars].filter(n => mainSideVars.has(n));
            if (sharedNames.length > 0) {
                alert(Message.alertVariableSharedWithTimer[this.setLocale()].replace('[NAMES]', sharedNames.join('，')));
            }
        }
        // --- タイマー割り込み機能(試験段階)のため volatile 修飾を追加 ---
        // 元の処理:
        // for (let id in variables) {
        //     let variableName = converter.modifyVariableName(variables[id][0]);
        //     converter.variables.push(variableName);
        //     src_init += `float ${variableName} = 0.0; // 変数ブロック: ${variables[id][0]}\n`;
        // }
        for (const id in variables) {
            const rawVarName = variables[id][0];
            const variableName = converter.modifyVariableName(rawVarName);
            converter.variables.push(variableName);
            const qualifier = converter.timerSharedVars.has(rawVarName) ? 'volatile ' : '';
            src_init += `${qualifier}float ${variableName} = 0.0; // 変数ブロック: ${rawVarName}\n`;
        }
        for (const id in lists) {
            const name = lists[id][0];
            const listDeclareSource = `arx::vector<int> ${converter.modifyListName(name)} {}; // リストブロック: ${name}\n`;
            src_init += listDeclareSource;
        }
        const funcContentSource = '';

        // debug用
        // for (let blockID in blocks) {
        // console.log(blocks);
        // console.log(blocks[blockID]);
        // }
        // Arduino言語への変換
        for (const id in blocks) {
            switch (blocks[id].opcode) {
            case 'makerBoard_starthat': // Setup code
                if (setupCodeCount == 0){
                    setupCodeCount += 1;
                } else {
                    alert(Message.alertMultipleStart[this.setLocale()]);
                    setupCodeCount += 1;
                    writeFlag = false;
                    break;
                }

                // init
                const rsltSetupInit = converter.initConvert(id, blocks);
                src_include += rsltSetupInit[0];
                src_init += rsltSetupInit[1];
                src_setup += converter.indent(rsltSetupInit[2], 2);
                // 処理
                const rsltSetup = converter.convertSnippet(id, blocks);
                const snippetSetup = rsltSetup;
                src_setup += converter.indent(snippetSetup, 2);
                writeFlag = true;
                break;
            case 'makerBoard_loopcode':
                if (loopCodeCount == 0){
                    loopCodeCount += 1;
                } else {
                    alert(Message.alertMultipleLoop[this.setLocale()]);
                    loopCodeCount += 1;
                    writeFlag = false;
                    break;
                }
                // ループコード内に何もなければ中括弧を閉じて返す
                if (!('SUBSTACK' in blocks[id].inputs)){
                    src_loop += '}\n\n';
                    break;
                }
                const insideBlockID = blocks[id].inputs.SUBSTACK[1]; // 繰り返し動かす内の先頭ブロックID
                // init
                const rsltLoopInit = converter.initConvert(insideBlockID, blocks);
                src_include += rsltLoopInit[0];
                src_init += rsltLoopInit[1];
                src_setup += converter.indent(rsltLoopInit[2], 2);
                // 処理
                const rsltLoop = converter.convertSnippet(insideBlockID, blocks);
                const snippetLoop = rsltLoop;
                src_loop += converter.indent(snippetLoop, 2);
                src_loop += '}\n\n';
                writeFlag = true;
                if (blocks[id].next){
                    alert(Message.alertBlocksBelowLoop[this.setLocale()]);
                    writeFlag = false;
                }
                break;
            case 'makerBoardAdvance_timerLoop':
                // 「繰り返し動かす」ブロックの外側に独立して配置するブロック
                if (blocks[id].parent) {
                    alert(Message.alertTimerOutsideLoop[this.setLocale()]);
                    writeFlag = false;
                    break;
                }
                if (timerInterruptCount == 0){
                    timerInterruptCount += 1;
                } else {
                    alert(Message.alertMultipleTimer[this.setLocale()]);
                    timerInterruptCount += 1;
                    writeFlag = false;
                    break;
                }
                if (blocks[id].next){
                    alert(Message.alertBlocksBelowTimer[this.setLocale()]);
                    writeFlag = false;
                }
                // 周期 (ms)
                const timerIntervalSrc = converter.processValueInfo(blocks[id].inputs.INTERVAL, blocks);
                if (typeof timerIntervalSrc === 'string' && timerIntervalSrc.includes('"')){
                    alert(Message.alertTimerIntervalNotNumber[this.setLocale()]);
                    writeFlag = false;
                    break;
                }
                // MsTimer2ライブラリ (Timer2割り込み) を利用
                src_include += `#include <MsTimer2.h>\n`;
                // 共有変数のアトミックアクセス用ヘルパ
                if (converter.timerSharedVars.size > 0) {
                    src_func += `\nstatic inline float _readAtomic(volatile float* v) {\n  uint8_t _sreg = SREG;\n  cli();\n  float _r = *v;\n  SREG = _sreg;\n  return _r;\n}\nstatic inline void _writeAtomic(volatile float* v, float x) {\n  uint8_t _sreg = SREG;\n  cli();\n  *v = x;\n  SREG = _sreg;\n}\n`;
                }
                // SUBSTACKがあるときだけハンドラ本体を生成
                let timerInnerSnippet = '';
                if ('SUBSTACK' in blocks[id].inputs) {
                    const insideTimerID = blocks[id].inputs.SUBSTACK[1];
                    const rsltTimerInit = converter.initConvert(insideTimerID, blocks);
                    src_include += rsltTimerInit[0];
                    src_init += rsltTimerInit[1];
                    src_setup += converter.indent(rsltTimerInit[2], 2);
                    converter.inTimerHandler = true;
                    timerInnerSnippet = converter.convertSnippet(insideTimerID, blocks);
                    converter.inTimerHandler = false;
                }
                // タイマー割り込み内で delay() を呼ぶブロックを検出 (待つブロック等)
                if (/\bdelay(Microseconds)?\s*\(/.test(timerInnerSnippet)) {
                    alert(Message.alertDelayInsideTimer[this.setLocale()]);
                    writeFlag = false;
                }
                src_func += `void _timerInterruptHandler() {\n${converter.indent(timerInnerSnippet, 2)}}\n\n`;
                src_setup += converter.indent(`MsTimer2::set(${timerIntervalSrc}, _timerInterruptHandler);\nMsTimer2::start();\n`, 2);
                break;
            }
        }
        // 定義ブロックは使ったときのみinit処理と関数定義
        const proceduresCall = converter.getProceduresCall(); // 利用した定義ブロックの関数名を取得
        for (const id in blocks) {
            const blockInfo = blocks[id];
            switch (blocks[id].opcode) {
            case 'procedures_definition':
                const procProtoBlockID = blockInfo.inputs.custom_block[1];
                const proccodes = blocks[procProtoBlockID].mutation.proccode.split(' ');
                const plainFunctionName = proccodes[0];
                const calledFunction = converter.modifyFunctionName(plainFunctionName);
                if (proceduresCall.includes(calledFunction)){
                    console.log(plainFunctionName);
                    if (!this.existFunctionNames.has(plainFunctionName)){
                        this.existFunctionNames.add(plainFunctionName);
                    } else {
                        alert(Message.alertDuplicateDefinition[this.setLocale()].replace('[NAME]', proccodes[0]));
                        writeFlag = false;
                        break;
                    }
                    // init
                    const rsltFuncInit = converter.initConvert(id, blocks);
                    src_include += rsltFuncInit[0];
                    src_init += converter.indent(rsltFuncInit[1], 2);
                    src_setup += converter.indent(rsltFuncInit[2], 2);
                    // 処理
                    const snippet = converter.convertSnippet(id, blocks);
                    const funcName = converter.funcDefinition(id, blocks);
                    src_init += `${funcName};  // ブロック定義: ${plainFunctionName}\n`; // プロトタイプ宣言する
                    src_func += `${funcName}{\n`;
                    src_func += converter.indent(snippet, 2);
                    src_func += '}\n\n';
                }
                break;
            }
        }

        if (!setupCodeCount && !loopCodeCount && !timerInterruptCount) alert(Message.alertNoStartOrLoop[this.setLocale()]);
        if (!loopCodeCount) src_loop += '}\n'; // loopブロックが無い時，setup()の中括弧を閉じる
        if (loopCodeCount > 1 || setupCodeCount > 1) writeFlag = false; // 繰り返し動かすブロックが2つ以上あるとき書き込まない
        // 速度指定DCモータブロック (MsTimer2を使用) とタイマー割り込みブロックの併用を禁止
        if (timerInterruptCount > 0 && converter.motorInit) {
            alert(Message.alertTimerMotorConflict[this.setLocale()]);
            writeFlag = false;
        }

        this.existFunctionNames.clear();

        writeFlag = writeFlag && converter.getWriteFlag();

        // ========================================
        // TinyMLモデルの注入
        // ========================================
        if (converter.tinymlDeployed) {
            console.log('[MakerBoard] TinyMLモデルを統合します...');

            // 共有オブジェクトから取得
            const shared = (typeof window !== 'undefined') ? window.TinyMLShared : null;

            console.log('[MakerBoard] 共有オブジェクト:', shared);

            if (!shared || !shared.isModelTrained || !shared.model) {
                alert(Message.alertTinyMLNotTrained[this.setLocale()]);
                writeFlag = false;
            } else {
                try {
                    console.log('[MakerBoard] モデル情報:', {
                        model: !!shared.model,
                        labelMapSize: shared.labelMap ? shared.labelMap.size : 0,
                        accuracy: shared.validationAccuracy
                    });

                    // 一時的なインスタンスを作成してコード生成メソッドを使用
                    const tempExt = new TinyMLExtension(this.runtime);
                    tempExt.model = shared.model;
                    tempExt.labelMap = shared.labelMap;
                    tempExt.trainingAccuracy = shared.trainingAccuracy;
                    tempExt.validationAccuracy = shared.validationAccuracy;

                    // モデルコード生成
                    // const modelCode = tempExt.generateInferenceCode();
                    const modelCode = await tempExt.generateOptimizedInferenceCode();

                    console.log('[MakerBoard] 生成されたモデルコード（先頭500文字）:');
                    console.log(`${modelCode.substring(0, 500)}...`);

                    // プレースホルダーの確認
                    if (!src_init.includes('TINYML_MODEL_CODE_PLACEHOLDER')) {
                        console.error('[MakerBoard] プレースホルダーが見つかりません！');
                        console.log('[MakerBoard] src_initの内容:', src_init);
                        alert(Message.alertTinyMLPlaceholderMissing[this.setLocale()]);
                        writeFlag = false;
                    } else {
                        // プレースホルダーを置換
                        src_init = src_init.replace(
                            '// TINYML_MODEL_CODE_PLACEHOLDER',
                            modelCode
                        );

                        console.log('[MakerBoard] TinyMLモデル統合完了');
                        console.log(`  - クラス数: ${shared.labelMap.size}`);
                        console.log(`  - 検証精度: ${shared.validationAccuracy.toFixed(1)}%`);
                    }

                } catch (error) {
                    console.error('[MakerBoard] TinyMLモデル統合エラー:', error);
                    alert(Message.alertTinyMLIntegrationFailed[this.setLocale()].replace('[MESSAGE]', error.message));
                    writeFlag = false;
                }
            }
        }
        console.log('===== Generated C++ Code =====');
        console.log(src_include);
        console.log(src_init);
        console.log(src_func);
        console.log(src_setup);
        console.log(src_loop);


        this.sources = `${src_include + src_init + src_func + src_setup}\n${src_loop}`;

        return writeFlag;
    }

    /**
    * @param {string} optTargetId Optional targetid for serializing costumes of a single target
    **/
    toJSON (optTargetId) {
        const sb3 = require('../../serialization/sb3');
        return StringUtil.stringify(sb3.serialize(this.runtime, optTargetId));
    }

    async write (){
        const writeFlag = await this.generate();
        let result;
        if (writeFlag){
            result = await confirm(Message.confirmWrite[this.setLocale()]);
        } else {
            result == false;
        }
        if (result){
            const runtime = this.runtime;
            let selectedPort;
            // 書き込みに使うポートをどの経路で得たかの診断用。issue #19 の原因切り分けに使う
            let portSource = 'none';
            if (!('serial' in navigator)) {
                throw new Error(Message.errorWebSerialNotSupported[this.setLocale()]);
            }

            // messaging 拡張がシリアルポートを掴んでいる場合はそれを一時的に解放してもらい、
            // 同じポートを再利用する（ユーザにポート再選択させない）
            const messaging = runtime.peripheralExtensions && runtime.peripheralExtensions.makerBoardMessage;
            const messagingWasConnected = !!(messaging && messaging.connecting);
            if (messagingWasConnected) {
                try {
                    selectedPort = await messaging.pauseForWrite();
                    if (selectedPort) {
                        portSource = 'messaging.pauseForWrite';
                    }
                } catch (error) {
                    console.error('Failed to pause messaging serial:', error);
                }
            }

            // TinyML 拡張がデータ収集ストリームを掴んでいる場合も同様に切断する。
            // ファームが書き換わるので resume は不要。
            //
            // 検出は3段階フォールバック:
            //   1. instance.port (新しいインスタンスが握っているポート)
            //   2. window.TinyMLShared.heldPort (グローバルに登録されているポート)
            //      ↑ HMR で古いインスタンスが残ったケースでもここに入っている
            //   3. instance.pauseForWrite() (どちらにも引っかからなければ何もしない)
            const tinymlShared = (typeof window !== 'undefined') ? window.TinyMLShared : null;
            const tinyml = tinymlShared ? tinymlShared.instance : null;
            const sharedHeldPort = tinymlShared ? tinymlShared.heldPort : null;
            const instancePortOpen = !!(tinyml && tinyml.port &&
                (tinyml.port.readable || tinyml.port.writable));
            const sharedPortOpen = !!(sharedHeldPort &&
                (sharedHeldPort.readable || sharedHeldPort.writable));

            // パターンA: 通常ケース — instance 経由で pauseForWrite を呼ぶ
            if (tinyml && typeof tinyml.pauseForWrite === 'function' &&
                (tinyml.isStreaming || instancePortOpen || sharedPortOpen)) {
                try {
                    const tinymlPort = await tinyml.pauseForWrite();
                    if (tinymlPort && !selectedPort) {
                        selectedPort = tinymlPort;
                        portSource = 'tinyml.pauseForWrite';
                    }
                } catch (error) {
                    console.warn('Failed to pause tinyml stream:', error);
                }
            }

            // パターンB: instance が反応しなかったが heldPort/heldReader が残っていれば
            // 直接解放する (HMR で別インスタンスが残った極端ケースの保険)
            // 重要: reader を先に cancel + releaseLock しないと port.close は失敗する
            const sharedHeldReader = tinymlShared ? tinymlShared.heldReader : null;
            if (sharedHeldReader) {
                try {
                    await sharedHeldReader.cancel();
                } catch (e) { /* ignore */ }
                try {
                    sharedHeldReader.releaseLock();
                } catch (e) { /* ignore */ }
                if (tinymlShared) tinymlShared.heldReader = null;
            }
            if (sharedHeldPort && (sharedHeldPort.readable || sharedHeldPort.writable)) {
                try {
                    await sharedHeldPort.close();
                } catch (e) { /* ignore */ }
                if (tinymlShared) tinymlShared.heldPort = null;
                if (!selectedPort) {
                    selectedPort = sharedHeldPort;
                    portSource = 'tinyml.heldPort';
                }
            }

            if (!selectedPort) {
                try {
                    selectedPort = await navigator.serial.requestPort();
                    if (selectedPort) {
                        portSource = 'requestPort';
                    } else {
                        throw new Error('No port selected');
                    }
                } catch (error) {
                    console.error('Port selection error:', error);
                    if (messagingWasConnected) {
                        try {
                            await messaging.resumeAfterWrite();
                        } catch (e) {}
                    }
                    throw new Error(Message.errorPortSelection[this.setLocale()] + error.message);
                }
            }

            const portId = describeSerialPort(selectedPort);
            console.info(`書き込みポート: source=${portSource}, VID:PID=${portId}, wasConnected=${messagingWasConnected}`);

            runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'compiling'});

            const board = 'pro-mini';
            const data = {board: 'pro', source: this.sources};
            let wrote = false;
            const resumeMessaging = async () => {
                if (messagingWasConnected) {
                    try {
                        await messaging.resumeAfterWrite();
                    } catch (e) {
                        console.warn('resumeAfterWrite failed:', e);
                    }
                }
            };
            await fetch(BUILD_SERVER_URL, {
            // await fetch('http://localhost:8080/exec/post', {
            // await fetch('http://0.0.0.0:8080/exec/post', {  //docker内build時
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(data), // 本文のデータ型は "Content-Type" ヘッダーと一致させる必要があります
                signal: AbortSignal.timeout(20000)
            }).then(async res => {
                if (!res.ok){
                    const data = await res.json();
                    console.error(data.text);
                    if (data.type === 'CompileError'){
                        throw new CompileError(`${data.text}`);
                    } else {
                        throw new Error(`${data.text}`);
                    }
                } else {
                    return res.arrayBuffer();
                }
            })
                .then(data => {
                // let avrgirl = new Avrgirl({
                //     board: board,
                //     port: 'dummy-port',
                //     debug: true,
                // });
                // console.info('compiling done.');
                    const writer = new ArduinoWriter({
                        board: board,
                        port: selectedPort, // 選択されたポートを使用
                        debug: false
                    });
                    const locale = this.setLocale();
                    runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'writing'});
                    // avrgirl.flash(data, function (error) {
                    // flash() はコールバック式なので Promise でラップして await できるようにする
                    return new Promise(resolve => {
                        writer.flash(data, error => {
                            if (error) {
                                console.error(error);
                                if (error.code === 8){} else if (error.name === 'SecurityError'){
                                    runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: Message.alertUSBAccessError[locale]});
                                } else {
                                    runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: Message.alertWriteFailedUSB[locale]});
                                }
                            } else {
                                wrote = true;
                                this.errorMessage = '';
                                runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'done'});
                                console.info('done.');
                            }
                            resolve();
                        });
                    });
                })
                .catch(error => {
                // console.info(error.message);
                    const locale = this.setLocale();
                    if (error instanceof CompileError){
                        this.errorMessage = error.message;
                        // サーバが整形した詳細メッセージ(メモリ不足の説明等)があればそれを表示。
                        // 無い場合のみ汎用の "プログラムが正しいか..." 文言にフォールバック。
                        const detailMessage = (error.message && error.message.trim()) ?
                            error.message :
                            Message.alertWriteFailedCompile[locale];
                        runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: detailMessage});
                    } else if (error.name === 'TimeoutError'){
                        runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: Message.alertTimeout[locale]});
                    } else if (error.name === 'TypeError'){
                        runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: Message.alertServerError[locale]});
                    } else {
                        console.error(error);
                        this.errorMessage = error.message;
                        // alert(`プログラムの書き込みにしっぱいしました．プログラムが正しいか，かくにんしてください．`)
                        runtime.emit('MAKERBOARD_WRITE_PROGRESS', {stage: 'error', message: Message.alertGenericError[locale]});
                    }
                })
                .finally(async () => {
                    await resumeMessaging();
                });
        }
    }
    exportFile (){
        this.generate();
        const blob = new Blob([this.sources], {type: 'text/plain;charset=utf-8'});
        FileSaver.saveAs(blob, 'source.ino');
    }
    errorMesg (){
        return this.errorMessage;
    }

    starthat (){}
    loopcode (){}

    motorforwardsimple (){}
    motorbackwardsimple (){}
    motorforward (){}
    motorbackward (){}
    motorstop (){}

    servo (){}
    led (){}
    ledanalog (){}
    touch (){}
    sound (){}
    buttonbool (){}
    joystick (){}
    joystickpush (){}

    rotary (){}
    initialize (){
        const date = new Date();
        src_include = `/*!
* This code created by https://kurikit.ux-xu.com/play/
* Date: ${date.toDateString()}
*/

#include <ArxContainer.h>
#include <Servo.h>
#include <Wire.h>
#include <MakerBoard.h>
`;
        src_init = `
MakerBoard board;
Servo Servo1;
Servo Servo2;
Servo Servo3;
Servo Servo4;

template <typename T_ty> struct TypeInfo { static const char * name; };
template <typename T_ty> const char * TypeInfo<T_ty>::name = "unknown";

#define TYPE_NAME(var) TypeInfo< typeof(var) >::name
#define MAKE_TYPE_INFO(type)  template <> const char * TypeInfo<type>::name = #type;

MAKE_TYPE_INFO( int )
MAKE_TYPE_INFO( float )
MAKE_TYPE_INFO( char )
\n`;

        src_func = `
uint8_t pin(uint8_t pin){
  switch(pin){
      case 1:
        return board.GROVE_CON1_SIG;
      case 2:
        return board.GROVE_CON2_SIG;
      case 3:
        return board.GROVE_CON3_SIG;
  }
}
uint8_t pin(uint8_t pin, uint8_t kind){
  uint8_t gpio;
  if (pin == board.GROVE_CON1_SIG){
      if (kind == 0) gpio = board.GROVE_CON1_SIG;
      else gpio = board.GROVE_CON1_OPT;
  }else if(pin == board.GROVE_CON2_SIG){
      if (kind == 0) gpio = board.GROVE_CON2_SIG;
      else gpio = board.GROVE_CON2_OPT;
  }
  else{
      if (kind == 0) gpio = board.GROVE_CON3_SIG;
      else gpio = board.GROVE_CON3_OPT;
  }
  return gpio;
}

int _random(int min, int max){
  return int(random(min, max+1));
}
uint8_t findIndex(arx::vector<int> list, int item){
  for(uint8_t i = 1; i < list.size()+1; i++){
      if(list[i-1] == item) return i;
  }
  return 0;
}
void errorStatus(String msg){
  while(1){
  digitalWrite(board.LED_RED, HIGH);
  delay(200);
  digitalWrite(board.LED_RED,LOW);
  delay(200);
  Serial.println(msg);
  }
}
float _toNumber(String str) {
  if (str.length() == 0) return 0;
  bool hasDecimal = false;
  for (int i = 0; i < str.length(); i++) {
    if (i == 0 && (str[i] == '-' || str[i] == '+')) continue;
    if (str[i] == '.' && !hasDecimal) { hasDecimal = true; continue; }
    if (!isDigit(str[i])) { Serial.println("e" + str); return NAN; }
  }
  return str.toFloat();
}
void _updateList(arx::vector<int>& list, String str) {
  list.clear();
  if (str.indexOf(' ') >= 0) {
    while (str.length() > 0) {
      int idx = str.indexOf(' ');
      if (idx < 0) idx = str.length();
      String token = str.substring(0, idx);
      float val = _toNumber(token);
      list.push_back(isnan(val) ? 0 : (int)val);
      str = (idx < (int)str.length() - 1) ? str.substring(idx + 1) : "";
    }
  } else {
    for (int i = 0; i < (int)str.length(); i++) {
      if (isDigit(str[i])) {
        list.push_back(str[i] - '0');
      } else {
        Serial.println("e" + String(str[i]));
      }
    }
  }
}
int joystickPos(uint8_t gpio){
  uint16_t val = analogRead(gpio);
  float offset = 0.05;
  int8_t duty = 0;
  if(val > 512 * (1 + offset) && val < 512 * (1 + offset)){
    return duty;
  }else{
    duty = map(val, 230, 765, -100, 100);
    return duty;
  }
}
\n`;

        src_setup = `void setup() {
  pinMode(board.LED_RED, OUTPUT);
  pinMode(board.LED_BLUE, OUTPUT);
  pinMode(board.SERVO1, OUTPUT);
  pinMode(board.SERVO2, OUTPUT);
  pinMode(board.SERVO3, OUTPUT);
  pinMode(board.SERVO4, OUTPUT);
  Servo1.attach(board.SERVO1);
  Servo2.attach(board.SERVO2);
  Servo3.attach(board.SERVO3);
  Servo4.attach(board.SERVO4);
  Serial.begin(38400);
\n`;
        src_loop = `}
void loop() {
  /* Write here your code */
`;
        this.writeFile = false;
    }

    // 現在のページのロケールを取得し、Messageに渡す。
    // 用意している言語以外は、英語で表示されるように。
    setLocale () {
        const locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        }
        return 'en';

    }
}

module.exports = MakerBoard;
